// @flow
import localStorage from 'localStorage';

export function getItem(key: string): ?any {
  const objectFromLocalStorage = localStorage.getItem(key);
  if (objectFromLocalStorage) {
    return JSON.parse(objectFromLocalStorage);
  }
  return {};
}

export function setItem(key: string, objectToBeStored: any): void {
  return localStorage.setItem(key, JSON.stringify(objectToBeStored));
}

export function removeItem(key: string): void {
  localStorage.removeItem(key);
}

export function getStorage(): any {
  return localStorage;
}



// WEBPACK FOOTER //
// ./src/common/utils/localStorage.js